var BROWSER_COMPATIBLE_MINIMUM_VERSION_IE = 11; 
var BROWSER_COMPATIBLE_MINIMUM_VERSION_FIREFOX = 59;
var BROWSER_COMPATIBLE_MINIMUM_VERSION_SAFARI = 11;
var BROWSER_COMPATIBLE_MINIMUM_VERSION_CHROME = 66;
var BROWSER_COMPATIBLE_MINIMUM_VERSION_EDGE = 18;

(function (exports) {
    // return object
    var browser = {
        getVersionAndName: function () {
            var info = {},
                v = 0;

            for (prop in browserMap) {
                info = browserMap[prop];

                var num = Ext[info.versionVariable];

                if (num > 0) {
                    v += num;
                    break;
                }
            }

            // if v == 0 no browser was matched, todo

            return {
                version: v,
                name: info.name
            };
        },
        getSupport: function () {

            var isBrowserUnsupported = function () {
                var unsupported = true;

                if (browser.isIE()) {  
                    //console.log("BROWSER IE VERSION VS MINIMUM = " + browser.getIEVersion() + " : " + BROWSER_COMPATIBLE_MINIMUM_VERSION_IE);
                    unsupported = (browser.getEdgeVersion() < BROWSER_COMPATIBLE_MINIMUM_VERSION_IE);
                }
                else if (browser.isEdge()) {
                    //console.log("BROWSER EDGE VERSION VS MINIMUM = " + browser.getEdgeVersion() + " : " + BROWSER_COMPATIBLE_MINIMUM_VERSION_EDGE);
                    unsupported = (browser.getEdgeVersion() < BROWSER_COMPATIBLE_MINIMUM_VERSION_EDGE);
                }
                else if (browser.isChrome()) {
                    //console.log("BROWSER CHROME VERSION VS MINIMUM = " + browser.getChromeVersion().major + " : " + BROWSER_COMPATIBLE_MINIMUM_VERSION_CHROME);
                    unsupported = (browser.getChromeVersion().major < BROWSER_COMPATIBLE_MINIMUM_VERSION_CHROME);
                }
                else if (browser.isFirefox()) {
                    //console.log("BROWSER FIREFOX/GECKO VERSION VS MINIMUM = " + browser.getFirefoxVersion() + " : " + BROWSER_COMPATIBLE_MINIMUM_VERSION_FIREFOX);
                    unsupported = (browser.getFirefoxVersion() < BROWSER_COMPATIBLE_MINIMUM_VERSION_FIREFOX);
                }
                else if (browser.isSafari()) {
                    //console.log("BROWSER SAFARI VERSION VS MINIMUM = " + browser.getSafariVersion() + " : " + BROWSER_COMPATIBLE_MINIMUM_VERSION_SAFARI);
                    unsupported = (browser.getSafariVersion() < BROWSER_COMPATIBLE_MINIMUM_VERSION_SAFARI);
                }
                else if (browser.isTablet()) {
                    unsupported = false;
                }
                
                return unsupported;
            };

            var userAgent = Ext.userAgent,
                isMobile = /Mobile/i.test(userAgent),
                isMobileUnsupported = false,
                isUnsupported = isBrowserUnsupported(),
                showPopup = isUnsupported,
                hasCookies = areCookiesEnabled(),
                hasEncryption = !isUnsupported;

            if (isMobile) {
                var isAndroid = /Android/i.test(userAgent),
                    isIos = /(iPad|iPhone)/i.test(userAgent),
                    version;

                if (isAndroid) {
                    version = parseFloat(userAgent.match(/Android (\d+\.\d+)/i)[1]);
                    isMobileUnsupported = version < 5.0;
                } else if (isIos) {
                    version = parseFloat(userAgent.match(/OS (\d+)_\d+/i)[1]);
                    isMobileUnsupported = version < 11;
                }
            }

            return {
                isMobile: isMobile,
                isMobileUnsupported: isMobileUnsupported,
                isUnsupported: isUnsupported,
                showPopup: showPopup,
                hasCookies: hasCookies,
                hasEncryption: hasEncryption
            };
        },
        showBrowserInfo: function () {
            displaySupportInfo();
        },
        isIE: function () {
            // hasActiveX will be able to detect all MSIE browsers, in particular MSIE11
            // Extjs has poor IE version detection, ie11 not recognized, userAgent string uses Trident/7.0 instead of MSIE
            // https://msdn.microsoft.com/en-us/library/ie/bg182625%28v=vs.85%29.aspx (tyvm microsoft_)
            var hasActiveX = "ActiveXObject" in window;
            return Ext.isIE || hasActiveX;
        },
        getIEVersion: function() {
            var ieVersion;
            var agent = navigator.userAgent;
            var reg = /MSIE\s?(\d+)(?:\.(\d+))?/i;
            var matches = agent.match(reg);

            if (matches != null) {
                ieVersion = matches[1];
            } else {
                ieVersion = 11;
            }
            return ieVersion;
        },
        isSafari: function () {
            return !browser.isChrome() && Ext.isSafari;
        },
        getSafariVersion: function () {
            return Ext.safariVersion;
        },
        isFirefox: function () {
            return Ext.isGecko;
        },
        getFirefoxVersion: function () {
            return Ext.firefoxVersion;
        },
        isChrome: function () {
            return Ext.isChrome || (navigator.userAgent.indexOf('CriOS') >= 0);
        },
        isEdge: function() {
            return (navigator.userAgent.indexOf('Edge') >= 0);
        },
        getEdgeVersion: function() {
            var ua = window.navigator.userAgent;

            var edge = ua.indexOf('Edge/');
            if (edge > 0) {
                // return version number
                return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
            } else {
                // we can't figure out the version number, so just let it pass
                return BROWSER_COMPATIBLE_MINIMUM_VERSION_EDGE;
            }
        },
        getChromeVersion: function () {
            var v = '0.0.0.0';
            if (Ext.isChrome) {
                v = Ext.chromeVersion + '.0.0.0';
            } else if (navigator.userAgent.match('CriOS')) {
                var idx = navigator.userAgent.indexOf('CriOS');
                v = navigator.userAgent.substr(idx + 6).split(' ')[0];
            }
            var a = v.split('.');
            return {
                major: parseInt(a[0]),
                minor: parseInt(a[1]),
                release: parseInt([2]),
                build: parseInt([3])
            };
        },
        isTablet: function () {
            return (/tabletapp/i.test(navigator.userAgent.toLowerCase()));
        }
    };

    exports.BrowserInfo = browser;

})(this);

var browserMap = {
    edge: {
        versionVariable: 'edgeVersion',
        minSupportedVersion: BROWSER_COMPATIBLE_MINIMUM_VERSION_EDGE,
        download: 'https://www.google.com/search?q=download+microsoft+edge',
        enableCookies: 'https://www.google.com/search?q=enable+cookies+in+edge',
        enableJavascript: 'https://www.google.com/search?q=enable+javascript+in+edge',
        name: 'Edge',
        code: 'edge',
        getSupportedVersionText: function () { return '2 most recent versions'; }
    },
    ie: {
        versionVariable: 'ieVersion',
        minSupportedVersion: BROWSER_COMPATIBLE_MINIMUM_VERSION_IE,
        download: 'https://www.google.com/search?q=download+internet+explorer',
        enableCookies: 'https://www.google.com/search?q=enable+cookies+in+internet+explorer',
        enableJavascript: 'https://www.google.com/search?q=enable+javascript+in+internet+explorer',
        name: 'Internet Explorer',
        code: 'ie',
        getSupportedVersionText: function () { return 'Version ' + this.minSupportedVersion.toString(); }
    },
    firefox: {
        versionVariable: 'firefoxVersion',
        minSupportedVersion: BROWSER_COMPATIBLE_MINIMUM_VERSION_FIREFOX,
        download: 'https://www.google.com/search?q=download+firefox',
        enableCookies: 'https://www.google.com/search?q=enable+cookies+in+firefox',
        enableJavascript: 'https://www.google.com/search?q=enable+javascript+in+firefox',
        name: 'Mozilla Firefox',
        code: 'ff',
        getSupportedVersionText: function () { return '2 most recent versions'; }
    },
    chrome: {
        versionVariable: 'chromeVersion',
        minSupportedVersion: BROWSER_COMPATIBLE_MINIMUM_VERSION_CHROME,
        download: 'https://www.google.com/search?q=download+chrome',
        enableCookies: 'https://www.google.com/search?q=enable+cookies+in+chrome',
        enableJavascript: 'https://www.google.com/search?q=enable+javascript+in+chrome',
        name: 'Google Chrome',
        code: 'chrome',
        getSupportedVersionText: function () { return '2 most recent versions'; }
    },
    safari: {
        versionVariable: 'safariVersion',
        minSupportedVersion: BROWSER_COMPATIBLE_MINIMUM_VERSION_SAFARI,
        download: 'https://www.google.com/search?q=download+safari',
        enableCookies: 'https://www.google.com/search?q=enable+cookies+in+safari',
        enableJavascript: 'https://www.google.com/search?q=enable+javascript+in+safari',
        name: 'Safari',
        code: 'safari',
        getSupportedVersionText: function () { return '2 most recent versions'; }
    },
    opera: {
        versionVariable: 'operaVersion',
        name: 'Opera',
        code: 'opera',
        getSupportedVersionText: function () { return '2 most recent versions'; }
    }
};

var limitedSupportMap = {
    ie: {
        versionVariable: 'ieVersion',
        minSupportedVersion: BROWSER_COMPATIBLE_MINIMUM_VERSION_IE,
        download: 'https://www.google.com/search?q=download+internet+explorer',
        enableCookies: 'https://www.google.com/search?q=enable+cookies+in+internet+explorer',
        enableJavascript: 'https://www.google.com/search?q=enable+javascript+in+internet+explorer',
        name: 'Internet Explorer',
        code: 'ie',
        getSupportedVersionText: function () { return 'Version ' + this.minSupportedVersion.toString(); }
    }
};

var mobileBrowserMap = {
    android: {
        icon: 'android.png',
        minSupportedVersion: 5.0,
        name: 'Chrome for Android',
        code: 'Android',
        getSupportedVersionText: function () { return '2 most recent versions'; }
    },
    ios: {
        icon: 'apple.png',
        minSupportedVersion: 11,
        name: 'Mobile Safari for iOS devices',
        code: 'iOS',
        getSupportedVersionText: function () { return '2 most recent versions'; }
    }
};

Ext.onReady(function () {
    var support = BrowserInfo.getSupport();
    var infoLink = $('#browser-support-info').click(function () {
        BrowserInfo.showBrowserInfo();
    });

    var hash = window.location.hash.replace('#', '');
    if (hash === '/browser-support')
        return infoLink.trigger('click');

    // first check whether or not browser is supported
    if (support.isMobile) {
        if (!Alkami.Utils.CookieHelper.readCookie('mobile_browser_no_warn') && support.isMobileUnsupported) {
            displayMobileUnsupportedMessage();
            return;
        }
    } else {
        if (!Alkami.Utils.CookieHelper.readCookie('browser_no_warn') && support.showPopup) {
            displayUnsupportedMessage();
            return;
        }
    }

    // then check whether or not cookies are enabled
    if (!support.hasCookies) {
        displayCookiesDisabledMessage();
    }

    $('div#sidebar a#help').instructify();
});

function displaySupportInfo() {
    var support = BrowserInfo.getSupport();
    var dialogTpl = new Ext.XTemplate(
        '<tpl for=".">',
            '<div class="supported-stats {supportCls} {encryptionCls} {cookiesCls}">',
                '<h3>{[values.supported && values.cookies && values.encryption ? "Your browser supports the minimum requirements:" : "Your browser doesn\'t quite meet the minimum requirements:"]}</h3>',
                '<ul>',
                    '<li class="{encryptionCls}"><strong>128-bit encryption</strong> {[values.encryption ? "is supported" : "may not be supported"]}</li>',
                    '<li class="{cookiesCls}"><strong>Cookies</strong> {[values.cookies ? "are supported" : "are not supported"]}</li>',
                    '<li class="{javascriptCls}"><strong>Javascript</strong> is enabled</li>',
                '</ul>',
            '</div>',
            '<h2>Desktop Browsers</h2>',
            '<p>In order to provide a better and more secure online banking experience to our users, we support the following browsers:</p>',
            '<ul class="supported-browsers-list list">',
                '<tpl for="supportedList">',
                    '<li class="{[xindex === xcount ? "last" : ""]}">',
                        '<img class="{code}" src="https://assets.orb.alkamitech.com/images/browser_unsupported/browsers/{code}.png" title="{name}" alt="{name}" />',
                        '<span class="name">{name}</span>',
                        '<span class="small">{[values.getSupportedVersionText()]}</span>',
                        '<a target="_blank" title="{name}" href="{download}">Download</a>',
                    '</li>',
                '</tpl>',
            '</ul>',
        '<h2>Browsers with Limited Support</h2>',
        '<ul class="supported-browsers-list list">',
            '<tpl for="limitedSupportedList">',
                '<li class="{[xindex === xcount ? "last" : ""]}">',
                    '<img class="{code}" src="https://assets.orb.alkamitech.com/images/browser_unsupported/browsers/{code}.png" title="{name}" alt="{name}" />',
                    '<span class="name">{name}</span>',
                    '<span class="small">{[values.getSupportedVersionText()]} and older</span>',
                '</li>',
            '</tpl>',
        '</ul>',
        '<h2>Mobile Browsers</h2>',
            '<p>Online banking is designed to work with touch-based operating systems commonly found on tablet devices. We support the following mobile operating systems:</p>',
            '<ul class="mobile-list list">',
                '<tpl for="mobileSupportedList">',
                    '<li class="{[xindex === xcount ? "last" : ""]}"><img class="{code}" src="https://assets.orb.alkamitech.com/images/browser_unsupported/{icon}" title="{name}" alt="{name}" /><span class="name">{name}</span><span class="small">{[values.getSupportedVersionText()]}</span></li>',
                '</tpl>',
            '</ul>',
            '<h2>Browser Features</h2>',
            '<p>The following features need to be enabled in your browser:</p>',
            '<ul class="features-list list">',
                '<li><span class="js name">Javascript</span><span class="small">View instructions for your browser:</span>{[this.getInstructions("enableJavascript", values)]}</li>',
                '<li><span class="cookies name">Cookies</span><span class="small">View instructions for your browser:</span>{[this.getInstructions("enableCookies", values)]}</li>',
                '<li class="last"><span class="enc name">128-bit encryption</span></li>',
            '</ul>',
        '</tpl>',
        {
            getInstructions: function (type, data) {
                var html = [];
                for (var i = 0; i < data.supportedList.length; i++) {
                    html.push('<a target="_blank" class="' + data.supportedList[i].code + '" href="' + data.supportedList[i][type] + '"><img src="https://assets.orb.alkamitech.com/images/browser_unsupported/browsers/' + data.supportedList[i].code + '.png" alt="' + data.supportedList[i].name + '" /></a>');
                }

                return '<span class="browsers">' + html.join('') + '</span>';
            }
        }
    );

    var bbar = {
        //style: { padding: '0 20px 20px' },
        unstlye: true,
        plain: true,
        cls: 'close-bar',
        items: ['->', {
            text: 'Close',
            cls: 'button secondary',
            handler: function () {
                Ext.getCmp('browser-support').destroy();
            }
        }]
    };

    var win = displayWarning({
        title: 'Supported Browsers',
        id: 'browser-support',
        bodyClass: 'browser-support-info',
        tpl: dialogTpl,
        bbar: bbar
    });

    var supportedList = [];
    for (var prop in browserMap) {
        if (browserMap[prop].minSupportedVersion !== undefined)
            supportedList.push(browserMap[prop]);
    }

    var limitedSupportedList = [];
    for (var prop in limitedSupportMap) {
        if (limitedSupportMap[prop].minSupportedVersion !== undefined)
            limitedSupportedList.push(limitedSupportMap[prop]);
    }

    var mobileSupportedList = [];
    for (var prop in mobileBrowserMap) {
        if (mobileBrowserMap[prop].minSupportedVersion !== undefined)
            mobileSupportedList.push(mobileBrowserMap[prop]);
    }

    Ext.getCmp('browser-support-content').update({
        info: BrowserInfo.getVersionAndName(),
        supported: !support.isUnsupported,
        encryption: support.hasEncryption,
        cookies: support.hasCookies,
        supportedList: supportedList,
        limitedSupportedList: limitedSupportedList,
        mobileSupportedList: mobileSupportedList,
        // cls
        supportCls: support.isUnsupported ? 'not-ok' : 'ok',
        encryptionCls: !support.hasEncryption ? 'maybe-not-ok' : 'ok',
        cookiesCls: !support.hasCookies ? 'not-ok' : 'ok',
        javascriptCls: 'ok'
    });
};

function displayUnsupportedMessage() {
    var dialogTpl = new Ext.XTemplate(
        '<tpl for=".">',
            '<div class="explanation">',
                '<h1>Please update your browser.</h1>',
                '<p class="p1">Our online banking site uses the latest technology and security standards supported by modern browsers. In order to provide a better and more secure online banking experience to our users, we do not support the browser you are using. We apologize for the inconvenience.</p>',
                '<p class="p2">You may update to a newer version of your browser or download one of the supported browsers using the links below. You will be on your way to a better, faster and safer online browsing experience in no time!</p>',
                '<div class="browsers browser-not-supported">',
                    '<div class="browser edge">',
                        '<div class="wrap">',
                            '<div class="icon"></div>',
                            '<h3>Edge</h3>',
                            '<small>version {[browserMap.edge.minSupportedVersion]} or above</small>',
                        '</div>',
                        '<a target="_blank" href="{[browserMap.edge.download]}" class="{[this.getUpdateOrDownload(values.code, "edge")]}">Download</a>',
                    '</div>',
                    '<div class="browser firefox">',
                        '<div class="wrap">',
                            '<div class="icon"></div>',
                            '<h3>Firefox</h3>',
                            '<small>version {[browserMap.firefox.minSupportedVersion]} or above</small>',
                        '</div>',
                        '<a target="_blank" href="{[browserMap.firefox.download]}" class="{[this.getUpdateOrDownload(values.code, "ff")]}">Download</a>',
                    '</div>',
                    '<div class="browser chrome">',
                        '<div class="wrap">',
                            '<div class="icon"></div>',
                            '<h3>Google Chrome</h3>',
                            '<small>version {[browserMap.chrome.minSupportedVersion]} or above</small>',
                        '</div>',
                        '<a target="_blank" href="{[browserMap.chrome.download]}" class="{[this.getUpdateOrDownload(values.code, "chrome")]}">Download</a>',
                    '</div>',
                    '<div class="browser safari last">',
                        '<div class="wrap">',
                            '<div class="icon"></div>',
                            '<h3>Safari</h3>',
                            '<small>version {[browserMap.safari.minSupportedVersion]} or above</small>',
                        '</div>',
                        '<a target="_blank" href="{[browserMap.safari.download]}" class="{[this.getUpdateOrDownload(values.code, "safari")]}">Download</a>',
                    '</div>',        
                    '<div class="clear"></div>',
                '</div>',
                '<small>If you are using a supported browser, you may be using an extension that interferes with browser detection. Try disabling your browser extensions and restarting your browser to resolve the problem.</small>',
                '</div>',
            '<span class="or">OR</span>',
            '<div class="warnings">',
                '<h2>Continue without updating.</h2>',
                '<p>Please keep in mind that there are certain risks associated with using an outdated browser:',
                '<dl>',
                    '<dt>Security Issues</dt>',
                    '<dd class="icon security"></dd>',
                    '<dd class="def">Serious security flaws and lack of privacy features needed to keep your account safe and secure.</dd>',
                '</dl>',
                '<dl>',
                    '<dt>Bugs</dt>',
                    '<dd class="icon bugs"></dd>',
                    '<dd class="def">Bugs and limitations that may create problems when you use websites.</dd>',
                '</dl>',
                '<dl class="last">',
                    '<dt>Missing Features</dt>',
                    '<dd class="icon missing"></dd>',
                    '<dd class="def">Some features may not be available which may make websites harder to use.</dd>',
                '</dl>',
            '</div>',
        '</tpl>',
        {
            compiled: true,
            getUpdateOrDownload: function (browserCode, browser) {
                return (browserCode == browser) ? 'update' : 'download';
            }
        }
    );

    var bbar = {
        style: {
            padding: '0 20px 20px'
        },
        items: [{
            xtype: 'checkbox',
            name: 'dont_warn',
            id: 'browser_no_warn',
            boxLabel: 'Do not warn me again'
        },
        '->',
        {
            text: 'I understand the risks',
            width: 140,
            height: 24,
            handler: function () {
                // close window and if dont_warn is checked, set cookie.
                if (!Alkami.Utils.CookieHelper.readCookie('browser_no_warn')) {
                    if (navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/')) {
                        Alkami.Utils.CookieHelper.createCookie('browser_no_warn', 'IE11', 30);
                    }
                    else {
                        Alkami.Utils.CookieHelper.createCookie('browser_no_warn', '!IE11', 1);
                    }
                }
                Ext.getCmp('browser_unsupported').destroy();
            }
        }]
    };

    displayWarning({ bodyClass: 'browser-unsupported', tpl: dialogTpl, bbar: bbar });

    var browser = null;

    if (Ext.isIE) {
        browser = limitedSupportMap.ie;
    } else if (navigator.userAgent.indexOf('Edge') >= 0) {
        browser = browserMap.edge;
    } else if (Ext.isSafari) {
        browser = browserMap.safari;
    } else if (Ext.isGecko) {
        browser = browserMap.firefox;
    } else if (Ext.isChrome) {
        browser = browserMap.chrome;
    } else if (Ext.isOpera) {
        browser = browserMap.opera;
    } else {
        browser = {};
    }

    Ext.getCmp('browser_unsupported_content').update(browser);

    $.each($(".localization"), function(i, e) {
        var item = $(e);
        var selector = item.data('selector');
        var localized = item.data('localized');
        if (selector) {
            $(selector).html(localized);
        }
    });

}

function displayMobileUnsupportedMessage() {
    var dialogTpl = new Ext.XTemplate(
        '<tpl>',
        '<div class="explanation">',
            '<h1>Your mobile operating system is not supported.</h1>',
            '<p>Our online banking site uses the latest technology and security standards supported by modern browsers. In order to provide a better and more secure online banking experience to our users, we do not support the browser you are using. We apologize for the inconvenience.</p>',
        '</div>',
        '<div class="support">',
            '<p>We support the following mobile operating systems:</p>',
            '<ul class="browsers">',
                '<li class="browser" id="ios_browser">',
                    '<span>Mobile Safari for iOS devices</span>',
                    '<small>iOS 11 or above</small>',
                '</li>',
                '<li class="browser" id="android_browser">',
                    '<span>Chrome for Android</span>',
                    '<small>Android 5.0 or above</small>',
                '</li>',
            '</ul>',
        '</div>',
        '</tpl>',
        {
            compiled: true
        }
    );

    var bbar = {
        style: {
            padding: '0 20px 20px'
        },
        items: [{
                xtype: 'checkbox',
                name: 'dont_warn',
                id: 'mobile_browser_no_warn',
                boxLabel: 'Do not warn me again'
            },
            '->',
            {
                text: 'Continue Anyway',
                width: 108,
                height: 24,
                handler: function() {
                    // close window and if dont_warn is checked, set cookie.
                    if (!Alkami.Utils.CookieHelper.readCookie('mobile_browser_no_warn')) {
                        Alkami.Utils.CookieHelper.createCookie('mobile_browser_no_warn','mobile', 1);
                    }
                    Ext.getCmp('browser_unsupported').destroy();
                }
            }]
    };

    displayWarning({ bodyClass: 'mobile-browser-unsupported', tpl: dialogTpl, bbar: bbar, ctCls: 'mobile' });
    Ext.getCmp('browser_unsupported_content').update({});
}

function displayCookiesDisabledMessage() {
    var dialogTpl = new Ext.XTemplate(
        '<div class="explanation">',
            '<h1>Please enable cookies.</h1>',
            '<p>Cookies need to be enabled in order for you to save settings and preferences. Please choose your browser below to view instructions on how to enable cookies. When you\'re done, refresh the page.</p>',
        '</div>',
        '<tpl for=".">',
        '<div class="browsers enable-cookies">',
            '<div class="browser ie">',
                '<div class="wrap">',
                    '<a target="_blank" href="{[values.ie.enableCookies]}">',
                        '<div class="icon"></div>',
                        '<h3>Internet Explorer</h3>',
                    '</a>',
                '</div>',
            '</div>',
            '<div class="browser edge">',
                '<div class="wrap">',
                    '<a target="_blank" href="{[values.edge.enableCookies]}">',
                        '<div class="icon"></div>',
                        '<h3>IE Edge</h3>',
                    '</a>',
                '</div>',
            '</div>',
            '<div class="browser firefox">',
                '<div class="wrap">',
                    '<a target="_blank" href="{[values.firefox.enableCookies]}">',
                        '<div class="icon"></div>',
                        '<h3>Firefox</h3>',
                    '</a>',
                '</div>',
            '</div>',
            '<div class="browser chrome">',
                '<div class="wrap">',
                    '<a target="_blank" href="{[values.chrome.enableCookies]}">',
                        '<div class="icon"></div>',
                        '<h3>Google Chrome</h3>',
                    '</a>',
                '</div>',
            '</div>',
            '<div class="browser safari last">',
                '<div class="wrap">',
                    '<a target="_blank" href="{[values.safari.enableCookies]}">',
                        '<div class="icon"></div>',
                        '<h3>Safari</h3>',
                    '</a>',
                '</div>',
            '</div>',
            '<div class="clear"></div>',
        '</div>',
        '</tpl>'
    );

    displayWarning({ bodyClass: 'enable-cookies', tpl: dialogTpl, bbar: null });

    Ext.getCmp('browser_unsupported_content').update(browserMap);
}

function displayWarning(opts) {
    var width = opts.width || 590,
        ctCls = opts.ctCls || '';

    var win = new Ext.Window({
        plain: true,
        title: opts.title,
        unstyled: true,
        hidden: false,
        id: opts.id || 'browser_unsupported',
        renderTo: Ext.getBody(),
        resizable: false,
        draggable: false,
        modal: !Ext.isIE6,
        shadow: !Ext.isIE,
        closable: false,
        closeAction: 'hide',
        layout: 'anchor',
        cls: 'modal dialog ' + ctCls,
        y: 50,
        width: width,
        autoHeight: true,
        items: [{
            id: opts.id ? opts.id + '-content' : 'browser_unsupported_content',
            cls: opts.bodyClass,
            tpl: opts.tpl
        }],
        bbar: opts.bbar
    });
    return win;
}

function areCookiesEnabled() {
    var r = false;
    Alkami.Utils.CookieHelper.createCookie("testing", "moo", 1);
    if (Alkami.Utils.CookieHelper.readCookie("testing") != null) {
        r = true;
        Alkami.Utils.CookieHelper.eraseCookie("testing");
    }
    return r;
}
